<template>
  <div class="magnit-faq">
    <div class="magnit-faq__headline">People Also Ask</div>
    <div class="magnit-faq__bodycopy">
      Key questions about our products and services.
    </div>
    <div class="magnit-faq__items">
      <div
        v-for="(item, index) in faqList"
        :key="`faq-${index + 1}`"
        :class="{ 'magnit-faq__item--active': item.opened }"
        class="magnit-faq__item"
      >
        <div class="magnit-faq__question" @click="handleClick(item)">
          Q. {{ item.question }}
          <span class="magnit-faq__icon"></span>
        </div>
        <div class="magnit-faq__answer">A : {{ item.answer }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  props: {
    // minHeight: {
    //   type: Number,
    //   required: false,
    //   default: 603,
    // },
  },
  data() {
    return {
      faqList: [
        {
          question: `What is micro LED LG MAGNIT and what technology does it use?`,
          answer: `LG MAGNIT is a micro LED display that utilizes LG's
          micrometer-sized LED technology to deliver precise, crystal-clear
          images with accurate color expression. It provides a true-to-life
          viewing experience with vivid colors and ultrafine details.`,
          opened: false,
        },
        {
          question: `How does micro LED LG MAGNIT achieve deeper black levels?`,
          answer: `LG MAGNIT uses black coating technology combined with a direct
          bonding method to deliver stunning black expressions. This makes it
          ideal for content requiring deep black color and true-to-life images.`,
          opened: false,
        },
        {
          question: `What features enhance the image uniformity of micro LED LG MAGNIT?`,
          answer: `LG MAGNIT features LST (LG Surface Treatment) technology which
          enhances white uniformity, reduces color distortion, and provides
          remarkable color uniformity. This results in superior image quality
          and precise wide-angle viewing experiences.`,
          opened: false,
        },
        {
          question: `What role does AI play in the micro LED LG MAGNIT viewing
          experience?`,
          answer: `LG MAGNIT is equipped with an advanced AI-powered Alpha 9
          Intelligent Processor (some models may have Alpha 7) that analyzes
          content and tailors display settings for each scene, creating a highly
          realistic and immersive image.`,
          opened: false,
        },
        {
          question: `What are the ideal usage scenarios for micro LED LG MAGNIT
          displays?`,
          answer: `LG MAGNIT is designed for diverse usage scenes including control
          rooms, boardrooms, virtual production and broadcasting, flagship
          retail boutiques, residential spaces, and VIP lounges. It enhances
          decision-making, communication, creativity, customer experience, and
          luxury environments.`,
          opened: false,
        },
        {
          question: `Could you tell me which certifications LG MAGNIT has received?`,
          answer: `Micro LED LG MAGNIT holds certifications for color consistency,
          low grayscale image quality, eye comfort, fire resistance, and
          electromagnetic compatibility. Micro LED LG MAGNIT is recognized for
          vibrant wide-angle viewing, precise dark scene reproduction, reduced
          blue light emission, and meet high standards for safety and
          electromagnetic stability with minimal interference.`,
          opened: false,
        },
      ],
    }
  },
  methods: {
    handleClick(item) {
      item.opened = !item.opened
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
$faq: '.magnit-faq';
#{$faq} {
  display: flex;
  flex-direction: column;
  padding: 60px 40px;

  border-top: solid 1px #dddee0;
  text-align: left;
  background-color: #fff;
  border-radius: 30px;

  &__headline {
    font-family: 'LG EI Headline';
    font-size: 30px;
    font-weight: 600;
    color: #000;
    border-top: solid 1px #c9caca;
    padding-top: 40px;
  }
  &__bodycopy {
    font-size: 24px;
    font-weight: 400;
    color: #000;
    margin-top: 48px;
  }

  &__items {
    margin-top: 40px;
  }

  &__item {
    border-top: solid 1px #c9caca;
    &:last-child {
      border-bottom: solid 1px #c9caca;
    }
    &--active {
      #{$faq}__answer {
        display: block;
      }
      #{$faq}__icon {
        transform: rotate(180deg) translateY(50%);
      }
    }
  }

  &__question {
    position: relative;
    font-family: 'LG EI Headline';
    font-size: 24px;
    font-weight: 600;
    color: #000;
    padding: 41px 86px 37px 26px;
    text-indent: -26px;
    cursor: pointer;
  }

  &__icon {
    width: 30px;
    height: 24px;
    background: url('/theme/rbFront/img/w/magnit/arrow_down.png') center center
      no-repeat;
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
  }

  &__answer {
    font-size: 24px;
    font-weight: 400;
    color: #000;
    line-height: 34px;
    background-color: #f0ece4;
    border-radius: 30px;
    padding: 40px 66px 40px 77px;
    text-indent: -32px;
    margin-bottom: 40px;
    display: none;
  }

  &--dark {
    #{$faq}__headline {
      color: #fff;
    }
    #{$faq}__bodycopy {
      color: #fff;
    }
    #{$faq}__item {
      border-top: solid 1px #dddee0;

      &:last-child {
        border-bottom: solid 1px #dddee0;
      }
    }

    #{$faq}__question {
      color: #fff;
    }

    #{$faq}__icon {
      background-image: url('/theme/rbFront/img/w/magnit/arrow_down_white.png');
    }
  }

  @media only screen and (min-width: 1081px) and (max-width: 1439px) {
  }
  @media only screen and (max-width: 1080px) {
    margin: 11.5px calcQuarter(60) 30px calcQuarter(60);
    padding: calcQuarter(74) calcQuarter(60) 0;
    border-radius: calcQuarter(30);

    &__headline {
      padding-top: 0;
      border: 0;
      font-size: calcQuarter(72);
    }
    &__bodycopy {
      font-size: calcQuarter(48);
      margin-top: 24px;
    }
    &__items {
      margin-top: 20px;
    }
    &__item {
      &:last-child {
        border-bottom: 0;
      }
    }
    &__question {
      font-size: 12px;
      padding: 20px 20px 19px 13px;
      text-indent: -13px;
    }

    &__icon {
      width: 13.5px;
      height: 9.5px;
      right: 0;
      background-size: contain;
    }

    &__answer {
      font-size: 12px;
      line-height: 17px;
      border-radius: calcQuarter(30);
      padding: 20px 22px 20px 27px;
      text-indent: -16px;
      margin-bottom: 20px;
    }
  }
}
</style>
